window.$catalog_work_resources_result = [];
window.$catalog_work_resources_treeChangeStatus = false;
window.$catalog_work_resources_page_number = 1;
window.$catalog_work_resources_Glist = [];
window.$catalog_work_resources_selectedRow = [];
window.$catalog_work_resources_content = [];
window.$catalog_work_resources_row_id = null;
window.$catalog_work_resources_algemeenCode = [];
window.$catalog_work_resources_algemeenNaam = [];
window.$catalog_work_resources_algemeenBestekspost = [];
window.$catalog_work_resources_algemeenKosteneenheid = [];
window.$catalog_work_resources_algemeenOmschrijving = [];
window.$catalog_work_resources_algemeenPrijs = [];
window.$catalog_work_resources_units_scroll_change = false;
window.$catalog_work_resources_lastUsedTableFilter = {
  content: [],
  definitions: [],
};
window.$catalog_work_resources_tableTotalpage = null;
window.$catalog_work_resources_selectedIds = null;
window.$catalog_work_resources_column_list = null;
window.$catalog_work_resources_table_total_row_count = 0;
window.$catalog_work_resources_columnListPure = null;

window.$catalog_work_resources_sliderImages = [];
window.$catalog_work_resources_context = null;
window.$catalog_work_resources_refresh = function (){};
window.$catalog_work_resources_actions = [
  {
    //id: "3eb8eaa0-a882-427a-8af3-7707d27b587b",
    id:"4c439c49-40e1-49f5-89cc-1df3af5b80c6",
    text: "Koppelen aan uitvoerder",
    class: "locate",
    modal: "koppelen_aan_uitvoerder",
  },
  {
    id: "1b2855cd-705a-4bfc-9b23-dad1807b7235",
    text: "Prijs per uitvoerder",
    class: "locate",
    modal: "werkplan_bewerk_prijs_per_uitvoerder",
  },
];
window.$catalog_work_resources_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>work-resources",
        column_list: [
          "checkbox",
          "active",
          "Naam",
          "Code",
          "paperclip",
          "Omschrijving",
          //"Type",
          "Prijs",
          "Kosteneenheid",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
